import { defineStore } from 'pinia';

const useOutCallStore = defineStore('outCall', {
  state: () => ({
    callConfig: {
      list: [], // 配置列表
      default: null // 默认配置
    }
  }),
  actions: {
    // 存储配置列表
    setCallConfig(list, defaultConfig) {
      this.callConfig.list = list; // 存储列表
      this.callConfig.default = defaultConfig; // 存储默认配置
    }
  }
});

export default useOutCallStore;
